function ContactController(containerObject){
	/* THIS FIX */
	var _this = this;
	
	/* PRIVATE CONSTANTS */
	var MAP_INIT_RETRY_MAX = 10;
	
	
	/* PRIVATE VARIABLES */
	var mapContainer;
	var mapInitRetryCount = 0;
	var multipleOffices = false;
	var markerImageUrl = null;
	

	/* PUBLIC PROPERTIES */
	this.container = null;
	this.inited = false;
	
	
	/* PRIVATE FUNCTIONS */
	function _construct(){
		_this.container = containerObject;
		_this.init();
	}	


	function mapInitCallback(){
		mapInitRetryCount ++;
		if (mapApiInited) {
			initMap();
		} else {
			if (mapInitRetryCount < MAP_INIT_RETRY_MAX) {
				setTimeout(mapInitCallback, 1000);
			}
		}
	}
	

	function initMap(){
		if(mapContainer.length === 1){
			if(multipleOffices) {
				initMapMultiple();
			} else {
				initMapSingle();
			}
		}
	};
	
	
	
	function initMapSingle(){
		var title = mapContainer.data('title');
		var address = mapContainer.data('address');
		var gpsLat = parseFloat(mapContainer.data('gpsLat'));
		var gpsLng = parseFloat(mapContainer.data('gpsLng'));
		var mapUrl = mapContainer.data('mapUrl');

		var markerImageSize = { width: 47, height: 64 };
		var pos = { lat: gpsLat, lng: gpsLng };
		var map = new google.maps.Map(document.getElementById('map-container'), {
			center: pos,
			zoom: 16,
			scrollwheel: false,
			signInControl: false
		});

		var contentString = '<div class="map-info-window-content">';
		contentString += '<h3>' + title + '</h3>';
		contentString += '<p>' + address + '</p>';
		if(mapUrl.length > 7) {
			contentString += '<p><a href="' + mapUrl + '" target="_blank">Zvětšit mapu</a></p>';
		}
		contentString += '</div>';

		var infowindow = new google.maps.InfoWindow({
			content: contentString,
			//pixelOffset: new google.maps.Size(-(markerImageSize.width/2),0)
		});
		
		var marker = createMarker(map, pos, title, markerImageSize);

		marker.addListener('click', function () {
			infowindow.open(map, marker);
		});		
	}
	
	
	function initMapMultiple(){
		if(officeMapData && officeMapData.length > 0){
			
			var markerImageSize = { width: 36, height: 48 };
			var bounds = new google.maps.LatLngBounds();
			var map = new google.maps.Map(document.getElementById('map-container'), {
				center: { lat: 50, lng: 14 },
				zoom: 16,
				scrollwheel: false,
				signInControl: false
			});			
			var infowindow = new google.maps.InfoWindow({
				//pixelOffset: new google.maps.Size(-(markerImageSize.width/2),0)
			});
			var infowindowContent = [];
			
			for(var i=0; i < officeMapData.length; i++) {
				var officeObj = officeMapData[i];

				var title = officeObj.pagetitle;
				var address = officeObj.mapAddress;
				var gpsLat = parseFloat(officeObj.mapGpsLat);
				var gpsLng = parseFloat(officeObj.mapGpsLng);
				var mapUrl = officeObj.mapUrl;
				var pos = { lat: gpsLat, lng: gpsLng };

				var contentString = '<div class="map-info-window-content">';
				contentString += '<h3>' + title + '</h3>';
				contentString += '<p>' + address + '</p>';
				if(mapUrl.length > 7) {
					contentString += '<p><a href="' + mapUrl + '" target="_blank">Zvětšit mapu</a></p>';
				}
				contentString += '</div>';
				// add content to array of contents
				infowindowContent[i] = contentString;

				var marker = createMarker(map, pos, title, markerImageSize);
				
				google.maps.event.addListener(marker, 'click', (function(marker, i) {
					return function () {
						infowindow.setContent(infowindowContent[i]);
						infowindow.open(map, marker);
					}
				 })(marker, i));
				
				//extend the bounds to include each marker's position
				bounds.extend(marker.position);
			}
			
			// fit map to all marker bounds
			map.fitBounds(bounds);
		}
	}
	
	
	function createMarker(map, position, title, markerImageSize){
		var image = {
			url: markerImageUrl,
			size: new google.maps.Size(markerImageSize.width, markerImageSize.height),
			scaledSize: new google.maps.Size(markerImageSize.width, markerImageSize.height),
			origin: new google.maps.Point(0, 0),
			anchor: new google.maps.Point(markerImageSize.height/2, markerImageSize.height)
		};

		var marker = (new google.maps.Marker({
			position: position,
			map: map,
			title: title,
			icon: image
		}));
		
		return marker;
	}
	
		
	
	/* PUBLIC FUNCTIONS */	
	this.init = function(){
		if(!_this.inited){	
			
			// object references
			mapContainer = $('#map-container');		
			
			// init
			var contactForm = new ContactForm($('#contact-form-container'));
			multipleOffices = parseInt(mapContainer.data('multipleOffices')) === 1 ? true : false;
			markerImageUrl = mapContainer.data('markerImage');

			mapInitCallback();

			_this.inited = true;
		}
	};
	

	/* INIT CONSTRUCTOR */
	_construct();
}


/* PUBLIC CONSTANTS */
